<template>
  <div>
    <v-container v-if="loadingPage" class="fill-height pa-0 align-start" fluid>
      <v-progress-linear indeterminate></v-progress-linear>
    </v-container>
    <v-container v-else :fluid="$vuetify.breakpoint.lgAndDown" class="px-8 py-2 white">
      <template v-if="dialogDelete">
        <v-dialog persistent v-model="dialogDelete" max-width="500">
          <v-card>
            <v-card-title class="error--text font-weight-bold">Eliminar Curso</v-card-title>
            <v-card-text
              class="font-weight-bold pb-1"
            >¿Estas seguro que deseas eliminar esta selección?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text rounded @click="dialogDelete = false">
                <v-icon class="mr-2">mdi-close</v-icon>no
              </v-btn>
              <v-btn color="success" text rounded @click="deleteCourse">
                <v-icon class="mr-2">mdi-check</v-icon>si
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog
        v-model="dialog"
        max-width="700"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
        scrollable
        @click:outside="closeDialog"
      >
        <v-card>
          <v-card-title>
            <span class="font-weight-bold title">{{dialogTitle}} Curso</span>
            <v-spacer></v-spacer>
            <v-btn class="ml-4" @click="closeDialog" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-2">
                  <BaseMyTextField
                    v-model="course.titulo"
                    label="Título *"
                    :error-messages="tituloErrors"
                    @input="$v.course.titulo.$touch()"
                    @blur="$v.course.titulo.$touch()"
                    required
                  ></BaseMyTextField>
                </v-col>
                <v-col cols="12" class="py-2">
                  <BaseMyTextArea
                    v-model="course.descripcion"
                    no-resize
                    counter="1000"
                    maxlength="1000"
                    label="Descripción"
                    :error-messages="descripcionErrors"
                    @input="$v.course.descripcion.$touch()"
                    @blur="$v.course.descripcion.$touch()"
                    required
                  ></BaseMyTextArea>
                </v-col>
                <v-col cols="12" class="py-2">
                  <BaseMyTextField
                    v-model="course.portada"
                    label="URL de Portada *"
                    :error-messages="portadaErrors"
                    @input="$v.course.portada.$touch()"
                    @blur="$v.course.portada.$touch()"
                    required
                  ></BaseMyTextField>
                </v-col>
                <v-col cols="12" class="py-2">
                  <BaseMyTextField v-model="course.video" label="URL de Video" required></BaseMyTextField>
                </v-col>
                <v-col cols="12" v-if="dialogTitle==='Editar'" class="d-flex justify-end py-0">
                  <v-radio-group v-model="course.estado" row hide-details class="mt-0">
                    <v-radio on-icon="mdi-checkbox-blank-circle" inset label="Activo" :value="true"></v-radio>
                    <v-radio
                      on-icon="mdi-checkbox-blank-circle"
                      inset
                      label="Completo"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-container fluid>
              <v-row>
                <v-col class="py-0 d-flex flex-wrap">
                  <span class="body-2 grey--text text--darken-1 mb-2">
                    <span class="font-weight-bold">*</span>
                    Indica los campos obligatorios
                  </span>
                  <v-spacer></v-spacer>
                  <div class="d-flex">
                    <BaseMyButton color="error" @click="closeDialog" :disabled="loading">Cancelar</BaseMyButton>
                    <BaseMyButton
                      v-if="dialogTitle==='Agregar'"
                      color="success"
                      class="ml-2"
                      :disabled="$v.invalid || loading"
                      :loading="loading"
                      @click="addCourse"
                    >Agregar</BaseMyButton>
                    <BaseMyButton
                      v-else
                      color="success"
                      class="mx-2"
                      :disabled="$v.invalid || loading"
                      :loading="loading"
                      @click="updateCourse"
                    >Guardar cambios</BaseMyButton>
                    <template v-if="dialogTitle==='Editar'">
                      <BaseMyButton color="error" @click="dialogDelete = true">
                        <v-icon>mdi-trash-can</v-icon>
                      </BaseMyButton>
                    </template>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col class="d-flex pb-0 flex-wrap">
          <p class="display-2 font-weight-bold mr-8">Cursos</p>
          <v-spacer></v-spacer>
          <BaseMyButton color="success" @click.stop="dialogTitle = 'Agregar'; dialog = true;">
            <v-icon class="mr-2">mdi-plus</v-icon>Nuevo curso
          </BaseMyButton>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Buscar cursos"
            filled
            dense
            hide-details
            rounded
            class="mb-3"
          ></v-text-field>
          <v-card flat>
            <v-data-table
              :headers="headers"
              :items="courses"
              :search="search"
              @click:row="selectCourse"
              class="transparent"
              style="cursor: pointer"
            >
              <template
                v-slot:item.descripcion="{ item }"
              >{{item.descripcion ? item.descripcion : 'No proporcionado'}}</template>
              <template v-slot:item.portada="{ item }">
                <v-img :src="item.portada" max-width="150"></v-img>
              </template>
              <template v-slot:item.video="{ item }">
                <v-chip
                  :class="['overline',item.video ? 'success--text':'red--text', 'font-weight-bold']"
                  :color="item.video ? 'success lighten-5':'red lighten-5'"
                  small
                >{{ item.video ? 'Si': 'No'}}</v-chip>
              </template>
              <template v-slot:item.estado="{ item }">
                <v-chip
                  :class="['overline',item.estado ? 'success--text':'red--text', 'font-weight-bold']"
                  :color="item.estado ? 'success lighten-5':'red lighten-5'"
                  small
                >{{ item.estado ? 'activo': 'completo'}}</v-chip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import store from "@/store";
import { mapState } from "vuex";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "AdminCourses",
  mixins: [validationMixin],

  validations: {
    course: {
      titulo: { required },
      descripcion: { required },
      portada: { required }
    }
  },

  data() {
    return {
      loadingPage: false,
      loading: false,
      dialogDelete: false,
      dialogTitle: "",
      dialog: false,
      search: "",
      headers: [
        {
          text: "Portada",
          align: "start",
          value: "portada",
          sortable: false,
          width: 100,
          class: "grey lighten-5"
        },
        {
          text: "Video",
          align: "center",
          value: "video",
          class: "grey lighten-5"
        },
        {
          text: "Titulo",
          align: "start",
          value: "titulo",
          width: 250,
          class: "grey lighten-5"
        },
        {
          text: "Descripción",
          value: "descripcion",
          class: "grey lighten-5"
        },
        {
          text: "Estado",
          value: "estado",
          class: "grey lighten-5",
          align: "center"
        }
      ],
      course: {
        titulo: "",
        descripcion: "",
        portada: "",
        video: "",
        estado: ""
      },
      courseDefault: {
        titulo: "",
        descripcion: "",
        portada: "",
        video: "",
        estado: ""
      }
    };
  },
  created() {
    this.getPageEvents();
  },

  computed: {
    ...mapState("administration/courses", ["courses"]),
    tituloErrors() {
      const errors = [];
      if (!this.$v.course.titulo.$dirty) return errors;
      !this.$v.course.titulo.required && errors.push("Campo necesario");
      return errors;
    },
    descripcionErrors() {
      const errors = [];
      if (!this.$v.course.descripcion.$dirty) return errors;
      !this.$v.course.descripcion.required && errors.push("Campo necesario");
      return errors;
    },
    portadaErrors() {
      const errors = [];
      if (!this.$v.course.portada.$dirty) return errors;
      !this.$v.course.portada.required && errors.push("Campo necesario");
      return errors;
    }
  },

  methods: {
    selectCourse(course) {
      this.dialogTitle = "Editar";
      store
        .dispatch("administration/courses/retrieveCourse", course._id)
        .then(response => {
          const courseRetrive = {
            _id: response._id,
            titulo: response.titulo,
            descripcion: response.descripcion,
            portada: response.portada,
            video: response.video,
            estado: response.estado
          };
          this.course = JSON.parse(JSON.stringify(courseRetrive));
        })
        .catch(error => {
          this.$store.commit("SET_ALERT", {
            color: "red",
            text: "Error al seleccionar curso",
            visible: true
          });
        })
        .finally(() => {
          this.dialog = true;
        });
    },
    getPageEvents() {
      this.loadingPage = true;
      store
        .dispatch("administration/courses/retrieveCourses")
        .then(() => {})
        .finally(() => {
          this.loadingPage = false;
        });
    },
    addCourse() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;
      delete this.course.estado;
      store
        .dispatch("administration/courses/addCourse", this.course)
        .then(() => {
          this.$store.commit("SET_ALERT", {
            color: "green",
            text: "Curso agregado",
            visible: true
          });
        })
        .catch(error => {
          this.$store.commit("SET_ALERT", {
            color: "red",
            text: "Error al agregar curso",
            visible: true
          });
        })
        .finally(() => {
          this.loading = false;
          this.closeDialog();
        });
    },
    updateCourse() {
      this.loading = true;
      store
        .dispatch("administration/courses/updateCourse", this.course)
        .then(() => {
          this.$store.commit("SET_ALERT", {
            color: "blue",
            text: "Curso actualizado",
            visible: true
          });
        })
        .catch(error => {
          this.$store.commit("SET_ALERT", {
            color: "red",
            text: "Error al editar curso",
            visible: true
          });
        })
        .finally(() => {
          this.closeDialog();
          this.loading = false;
        });
    },
    deleteCourse() {
      this.loading = true;
      store
        .dispatch("administration/courses/deleteCourse", this.course._id)
        .then(() => {
          this.$store.commit("SET_ALERT", {
            color: "red",
            text: "Curso eliminado",
            visible: true
          });
        })
        .catch(error => {
          this.$store.commit("SET_ALERT", {
            color: "red",
            text: "Error al eliminar curso",
            visible: true
          });
        })
        .finally(() => {
          this.dialogDelete = false;
          this.closeDialog();
          this.loading = false;
        });
    },
    closeDialog() {
      this.$v.$reset();
      this.dialog = false;
      this.course = JSON.parse(JSON.stringify(this.courseDefault));
    }
  }
};
</script>